import { authenticationGuard } from '@app/routes/auth';
import { Route, RouteConfig } from 'vue-router';

export async function getRoutes(): Promise<RouteConfig[]> {
	const routes: RouteConfig[] = [
		{
			path: `/preview/present/:environment/:locale([a-zA-Z\\-]{2,5})/:entryId`,
			name: 'preview-present',
			component: (): any => import('@views/present/200-LivePreview/LivePreviewPresent.vue'),
			beforeEnter: async (to: Route, from: Route, next: (route?: any) => void): Promise<void> => {
				authenticationGuard(to, from, next);
			}
		},
		{
			path: `/preview/share/:environment/:locale([a-zA-Z\\-]{2,5})/:entryId`,
			name: 'preview-share',
			component: (): any => import('@views/present/200-LivePreview/LivePreviewShare.vue'),
			beforeEnter: async (to: Route, from: Route, next: (route?: any) => void): Promise<void> => {
				authenticationGuard(to, from, next);
			}
		}
	];

	return routes;
}
